// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"df112342e8","784":"6cb63332b2"}[chunkId] + ".css";
};